import { ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { MatDialogRef } from '@angular/material/dialog';
import { UsersSelectionDialogComponent } from '../../../../../container-components/users-selection-dialog/users-selection-dialog.component';
import { UserSelectionItem } from '../../../../../container-components';
import { DEFAULT_PAGE_SIZE, ListQueryParam } from '../../../../../common/constants';

export interface CompartmentUserListURIParams {
  hubId: number;
  compartmentId: number;
  searchCriteria?: CompartmentAssignedUserListSearchCriteria | CompartmentAvailableUserListSearchCriteria;
}

export interface CompartmentUserAssignmentURIParams {
  dialog: MatDialogRef<UsersSelectionDialogComponent>;
  hubId: number;
  compartmentId: number;
  users: UserSelectionItem[];
}

export interface CompartmentUserDeassignmentURIParams {
  hubId: number;
  compartmentId: number;
  users: UserSelectionItem[];
}

export interface CompartmentUserUpdateUserPermissionsURIParams {
  hubId: number;
  compartmentId: number;
  user: UserSelectionItem;
}

export interface CompartmentUserAssignmentURIParams extends CompartmentUserDeassignmentURIParams {
  dialog: MatDialogRef<UsersSelectionDialogComponent>;
}

export class CompartmentAssignedUserListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;

  constructor(params?: CompartmentAssignedUserListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CompartmentAvailableUserListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: CompartmentAvailableUserListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
